module.exports = __webpack_public_path__ + "static/media/tap.7d2d16d0.svg";